import { Component, Prop, Vue } from "vue-property-decorator";

// External components
import ModalBase from "../modalBase/modalBase";

@Component({ components: { ModalBase } })
export default class ModalConfirmationMessage extends Vue {
  @Prop({ default: false }) isActive;
  @Prop({ default: "$modalTitle" }) title;
}
